module.exports = __webpack_public_path__ + "img/i1.ac9af171.png";